import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "styles/print.css";
import React, { useRef, useState, useEffect } from "react";
import ThaiBahtText from "thai-baht-text";
import { billData } from "mocks/billData";
import QRCode from "qrcode";
import moment from "moment";
import { getEmpFullNameTHByEmpData, getSupplierBranchPrintType, getSupplierFullAddress, getSupplierFullName, getUniqueWarehouseName, mappingPrintItemsData } from "utils/HelperFunction";
import { NumericFormat } from "react-number-format";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { COMPANY_LOGO } from "constants/server/api";
export function PRPrint(param) {
    var innerRef = param.innerRef, values = param.values, companyInfo = param.companyInfo;
    var maxRowPerPage = 10;
    var _useState = _sliced_to_array(useState(), 2), prow = _useState[0], setProw = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), page = _useState1[0], setPage = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), tmpRow = _useState2[0], setTmpRow = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), warehouses = _useState3[0], setWarehouses = _useState3[1];
    var _useState4 = _sliced_to_array(useState(), 2), qrBase64 = _useState4[0], setQrBase64 = _useState4[1];
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var loadData = function(prodItems) {
        var data = mappingPrintItemsData(prodItems);
        setWarehouses(getUniqueWarehouseName(prodItems));
        var p = Math.ceil(data.length / maxRowPerPage);
        setPage(p);
        var arr = [];
        for(var i = 1; i <= p; i++){
            var dataPage = data.slice((i - 1) * maxRowPerPage, (i - 1) * maxRowPerPage + maxRowPerPage);
            if (dataPage.length < maxRowPerPage) {
                setTmpRow(maxRowPerPage - dataPage.length);
            }
            var totals = dataPage.reduce(function(acc, item) {
                acc.totalQty += item.qty;
                acc.totalPriceBeforeTax += item.price_before_tax;
                return acc;
            }, {
                totalQty: 0,
                totalPriceBeforeTax: 0
            });
            dataPage.totals = totals;
            arr.push(dataPage);
        }
        setProw(arr);
    };
    useEffect(function() {
        setTmpRow(0);
        if (values && !!values.dimNewPurchaseReqItem) {
            loadData(values.dimNewPurchaseReqItem);
        }
    }, [
        values.dimNewPurchaseReqItem
    ]);
    useEffect(function() {
        var generateQRCode = function() {
            var _ref = _async_to_generator(function(value) {
                var qrUrl, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                QRCode.toDataURL(value)
                            ];
                        case 2:
                            qrUrl = _state.sent();
                            setQrBase64(qrUrl);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function generateQRCode(value) {
                return _ref.apply(this, arguments);
            };
        }();
        generateQRCode(values.doc_number);
    }, [
        values.doc_number
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: innerRef,
        children: prow && prow.map(function(item, index) {
            return /*#__PURE__*/ _jsx(PagePrint, {
                primaryData: values,
                warehouses: warehouses,
                pageCur: index + 1,
                pageAll: prow.length,
                pdata: item,
                tmpRow: tmpRow,
                maxRowPerPage: maxRowPerPage,
                qrBase64: qrBase64,
                companyInfo: companyInfo
            }, index);
        })
    });
}
var PagePrint = function(param) {
    var primaryData = param.primaryData, pageCur = param.pageCur, pageAll = param.pageAll, pdata = param.pdata, tmpRow = param.tmpRow, maxRowPerPage = param.maxRowPerPage, warehouses = param.warehouses, qrBase64 = param.qrBase64, companyInfo = param.companyInfo;
    var _primaryData_hqAddress;
    var _companyInfo_prefix_name, _companyInfo_suffix_name;
    return /*#__PURE__*/ _jsxs("div", {
        className: "text-[10.5px] text-[#2C2C2C] mb-1",
        style: {
            width: "210mm",
            height: "297mm",
            padding: "5px 30px",
            margin: "0",
            background: "white",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " flex text-[10.5px] items-end mb-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-start mr-auto mt-3 ",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mr-[15px]",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: COMPANY_LOGO,
                                    className: "w-[58px]"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "font-bold ",
                                        children: [
                                            "".concat((_companyInfo_prefix_name = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.prefix_name) !== null && _companyInfo_prefix_name !== void 0 ? _companyInfo_prefix_name : "").concat(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.company_name).concat((_companyInfo_suffix_name = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.suffix_name) !== null && _companyInfo_suffix_name !== void 0 ? _companyInfo_suffix_name : ""),
                                            " (สำนักงานใหญ่)"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "",
                                        children: (_primaryData_hqAddress = primaryData.hqAddress) === null || _primaryData_hqAddress === void 0 ? void 0 : _primaryData_hqAddress.fullAddress
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "",
                                        children: [
                                            "เลขผู้เสียภาษี / Tax ID ",
                                            companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.tax_id
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "mr-2",
                                                children: [
                                                    "Tel: (สำนักงานใหญ่)",
                                                    (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.phone_number) ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.phone_number : "-"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    "E-mail:",
                                                    (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.email) ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.email : "-"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "text-right mb-3",
                                children: [
                                    "แผ่นที่ ",
                                    pageCur,
                                    "/",
                                    pageAll
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: qrBase64,
                                        className: "w-[56px] mr-4"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "rounded-sm border text-center overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-[14px] py-1  text-white bg-[#575B5E]",
                                                children: "ใบขอซื้อ"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "px-2 py-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "เลขที่เอกสาร : "
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: primaryData.doc_number
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-end",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "grow pr-[20px]",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[130px]",
                                        children: "ข้อมูลผู้จัดจำหน่าย/Vendor"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000] ",
                                        children: "".concat(getSupplierFullName(primaryData.dimSupplierInformation), " - ").concat(getSupplierBranchPrintType(primaryData.dimSupplierInformation))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[130px]",
                                        children: "ที่อยู่/Address"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]",
                                        children: getSupplierFullAddress(primaryData.dimSupplierInformation)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[130px]",
                                        children: "เลขประจำตัวผู้เสียภาษี"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]",
                                        children: primaryData.dimSupplierInformation && primaryData.dimSupplierInformation.tax_identification_number ? primaryData.dimSupplierInformation.tax_identification_number : "-"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex-none mr-3",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[70px] mr-3 text-end",
                                        children: "วันที่ออกเอกสาร"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]",
                                        children: moment(primaryData.doc_issue_date).format("DD/MM/YYYY")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[70px] mr-3 text-end",
                                        children: "วันที่กำหนดส่ง"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]",
                                        children: moment(primaryData.delivery_date).format("DD/MM/YYYY")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[70px] mr-3 text-end",
                                        children: "เงื่อนไขชำระเงิน"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]",
                                        children: primaryData.dimMstPaymentType.name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex-none",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[70px] mr-3 text-end",
                                        children: "อ้างอิง"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]",
                                        children: primaryData.refer ? primaryData.refer : "-"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[70px] mr-3 text-end",
                                        children: "เวลาจัดส่ง"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]",
                                        children: primaryData.delivery_time
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[70px] mr-3 text-end",
                                        children: "ผู้จัดทำเอกสาร"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]",
                                        children: getEmpFullNameTHByEmpData(primaryData.createdNewPrEmp)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex pt-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "font-semibold text-[#000] min-w-[130px]",
                        children: [
                            "จำนวนจุดรับสินค้า : ",
                            warehouses.length
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "font-semibold text-[#000] ",
                        children: [
                            "จุดรับสินค้า : ",
                            warehouses.join(",")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-3",
                children: /*#__PURE__*/ _jsxs("table", {
                    className: "w-full  border-collapse border-slate-700 table-print",
                    children: [
                        /*#__PURE__*/ _jsx("thead", {
                            children: /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("th", {
                                        valign: "middle",
                                        width: "4%",
                                        style: {
                                            width: "4%"
                                        },
                                        className: "border-x border-y  text-center font-normal",
                                        children: "ที่"
                                    }),
                                    /*#__PURE__*/ _jsxs("th", {
                                        valign: "middle",
                                        width: "10%",
                                        className: "border-x border-y text-center font-normal",
                                        children: [
                                            "บาร์โค๊ด/",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "รหัส SUP"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        valign: "middle",
                                        width: "24%",
                                        className: "border-x border-y text-center font-normal",
                                        children: "รายละเอียด"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        valign: "middle",
                                        width: "1%",
                                        className: "border-x border-y text-nowrap text-center font-bold",
                                        children: "จำนวน"
                                    }),
                                    /*#__PURE__*/ _jsxs("th", {
                                        valign: "middle",
                                        width: "1%",
                                        className: "border-x border-y text-nowrap text-center font-normal",
                                        children: [
                                            "หน่วย",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "/อัตรา"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("th", {
                                        valign: "middle",
                                        width: "12%",
                                        className: "border-x border-y text-nowrap text-center font-normal",
                                        children: [
                                            "ราคา/",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "หน่วย"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        valign: "middle",
                                        width: "5%",
                                        className: "border-x border-y text-nowrap text-center font-normal",
                                        children: "ส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsxs("th", {
                                        valign: "middle",
                                        width: "5%",
                                        className: "border-x border-y text-nowrap text-center font-normal",
                                        children: [
                                            "VAT",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "CODE"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        valign: "middle",
                                        width: "5%",
                                        className: "border-x border-y text-nowrap text-center font-normal",
                                        children: "ยอดก่อนภาษี"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        valign: "middle",
                                        width: "3%",
                                        className: "border-x border-y text-nowrap text-center font-normal",
                                        children: "หมายเหตุ"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("tbody", {
                            children: [
                                pdata && pdata.map(function(item, i) {
                                    return /*#__PURE__*/ _jsxs("tr", {
                                        style: {
                                            height: "30px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-center",
                                                children: (pageCur - 1) * maxRowPerPage + (i + 1)
                                            }),
                                            /*#__PURE__*/ _jsxs("td", {
                                                className: "border-x pl-2 ellipsis",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: item.barcode
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "text-center",
                                                        children: item.supcode
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ",
                                                style: {
                                                    maxWidth: "100px"
                                                },
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    children: item.product
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x text-end ellipsis",
                                                children: item.qty
                                            }),
                                            /*#__PURE__*/ _jsxs("td", {
                                                className: "border-x ellipsis text-center text-[9px]",
                                                children: [
                                                    item.unit,
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    item.ratio_unit
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-end",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 4,
                                                    fixedDecimalScale: true,
                                                    value: item.price
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-end",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: item.discount
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-center",
                                                children: item.vat_code
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-end",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: item.price_before_tax
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis",
                                                style: {
                                                    maxWidth: "100px"
                                                },
                                                children: item.note
                                            })
                                        ]
                                    }, i);
                                }),
                                pageCur == pageAll ? _to_consumable_array(Array(tmpRow)).map(function(x, i) {
                                    return /*#__PURE__*/ _jsxs("tr", {
                                        style: {
                                            height: "42px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-center"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis"
                                            })
                                        ]
                                    }, "tmp".concat(i));
                                }) : ""
                            ]
                        }),
                        /*#__PURE__*/ _jsx("tfoot", {
                            children: /*#__PURE__*/ _jsxs("tr", {
                                style: {
                                    height: "30px"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "border-x border-y text-center font-semibold",
                                        colSpan: 3,
                                        children: "จำนวนสินค้ารวม"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "border-x border-y text-end font-semibold",
                                        children: /*#__PURE__*/ _jsx(NumericFormat, {
                                            displayType: "text",
                                            thousandSeparator: ",",
                                            decimalScale: 0,
                                            fixedDecimalScale: true,
                                            value: pdata.totals.totalQty
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "border-x border-y text-center font-semibold",
                                        colSpan: 4,
                                        children: "มูลค่าสินค้ารวมก่อนภาษี"
                                    }),
                                    /*#__PURE__*/ _jsxs("td", {
                                        className: "border-x border-y text-end font-semibold",
                                        children: [
                                            " ",
                                            /*#__PURE__*/ _jsx(NumericFormat, {
                                                displayType: "text",
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                value: pdata.totals.totalPriceBeforeTax
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "border-x border-y font-semibold"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-2 gap-2 text-[#000]",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mb-2",
                                children: "หมายเหตุ"
                            }),
                            /*#__PURE__*/ _jsx("textarea", {
                                className: "rounded-lg border pt-2 px-4 min-h-[156px] w-full resize-none",
                                name: "",
                                id: "",
                                value: primaryData.remark
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "pt-4",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "grid grid-cols-4 gap-1 mb-[7px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {}),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end",
                                                children: "มูลค่าสินค้าก่อนภาษี"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end",
                                                children: "ภาษีมูลค่าเพิ่ม"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end",
                                                children: "ราคารวม VAT"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "grid grid-cols-4 gap-1 mb-[7px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "NV สินค้าไม่มีภาษี"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: primaryData.total_price_product_no_vat + primaryData.total_price_product_zero_vat
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: "0.00"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: primaryData.total_price_product_no_vat + primaryData.total_price_product_zero_vat
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "grid grid-cols-4 gap-1 mb-[7px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "V สินค้าที่มีภาษี 7 % "
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: primaryData.total_price_product_seven_vat
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: primaryData.total_seven_vat_amount
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: primaryData.total_price_product_seven_vat + primaryData.total_seven_vat_amount
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "grid grid-cols-4 gap-1 mb-[7px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "มูลค่าสินค้ารวม"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: primaryData.total_price_before_vat
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: primaryData.total_price_vat
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-end pr-2",
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    value: primaryData.grand_total_price
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "pl-[70px]",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grid grid-cols-12 gap-2 mb-[7px] text-end",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-7",
                                        children: "มูลค่าสินค้ารวมภาษี"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-3",
                                        children: /*#__PURE__*/ _jsx(NumericFormat, {
                                            displayType: "text",
                                            thousandSeparator: ",",
                                            decimalScale: 2,
                                            fixedDecimalScale: true,
                                            value: primaryData.total_price_before_discount
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-2",
                                        children: "บาท"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grid grid-cols-12 gap-2 mb-[7px] text-end",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "col-span-7",
                                        children: [
                                            "ส่วนลด (",
                                            "".concat(primaryData.discount_value, " ").concat(primaryData.dimMstDiscountType.name),
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-3",
                                        children: /*#__PURE__*/ _jsx(NumericFormat, {
                                            displayType: "text",
                                            thousandSeparator: ",",
                                            decimalScale: 2,
                                            fixedDecimalScale: true,
                                            value: primaryData.discount_price
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-2",
                                        children: "บาท"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grid grid-cols-12 gap-2 mb-[7px] text-end",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-7",
                                        children: "มูลค่าสินค้าหลังหักส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-3",
                                        children: /*#__PURE__*/ _jsx(NumericFormat, {
                                            displayType: "text",
                                            thousandSeparator: ",",
                                            decimalScale: 2,
                                            fixedDecimalScale: true,
                                            value: primaryData.total_price_after_discount
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-2",
                                        children: "บาท"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: " py-1",
                                children: /*#__PURE__*/ _jsx("hr", {})
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grid grid-cols-12 gap-2 mb-[7px] text-end",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-7",
                                        children: "มูลค่าสินค้าก่อนภาษี"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-3",
                                        children: /*#__PURE__*/ _jsx(NumericFormat, {
                                            displayType: "text",
                                            thousandSeparator: ",",
                                            decimalScale: 2,
                                            fixedDecimalScale: true,
                                            value: primaryData.total_price_before_vat
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-2",
                                        children: "บาท"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grid grid-cols-12 gap-2 mb-[7px] text-end",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-7",
                                        children: "ภาษีมูลค่าเพิ่ม/VAT"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-3",
                                        children: /*#__PURE__*/ _jsx(NumericFormat, {
                                            displayType: "text",
                                            thousandSeparator: ",",
                                            decimalScale: 2,
                                            fixedDecimalScale: true,
                                            value: primaryData.total_price_vat
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-2",
                                        children: "บาท"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: " py-2 bg-[#EEEEEE] text-[11.5px]  mb-2",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-12 gap-2  text-end",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-span-7",
                                            children: "มูลค่ารวมสุทธิ/NET AMOUNT/VAT"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-span-3 font-bold",
                                            children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                displayType: "text",
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                value: primaryData.grand_total_price
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-span-2",
                                            children: "บาท"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "text-end text-[11.5px] text-[#000] font-semibold",
                                children: [
                                    "( ",
                                    ThaiBahtText(primaryData.grand_total_price),
                                    " )"
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: " py-2 text-[11.5px] pt-5  mb-2",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-2 gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-center  flex-col",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "h-[20px] border-b w-[100px] border-dashed border-black mb-2"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mb-2",
                                                    children: "วันที่ _____/_____/_____"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "",
                                                    children: "ผู้จัดทำ"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-center  flex-col",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "h-[20px] border-b w-[100px] border-dashed border-black mb-2"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mb-2",
                                                    children: "วันที่ _____/_____/_____"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "",
                                                    children: "ผู้อนุมัติ"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
